// extracted by mini-css-extract-plugin
export default {"link":"bnulRprlvqQD_NUXOpgc"};